import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12.587 12.95a.67.67 0 0 0 .413-.613V5.671a.666.666 0 1 0-1.333 0v5.06L4.14 3.196a.667.667 0 0 0-1.093.217.67.67 0 0 0 .146.73l7.534 7.527h-5.06a.667.667 0 0 0 0 1.333h6.666a.7.7 0 0 0 .254-.053"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })